import { withStyles } from '@material-ui/styles';
import classnames from 'classnames';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import queryString from 'query-string';
import { getClientInvisionIQKpiGrid } from '../../services';
import { AppContext } from '../../AppContext';
import { withRouter } from 'react-router';
import { AgGrid, filters } from '../../components/AgGrid';
import VirtualOrderConversionCellRenderer from '../../components/Orders/InvisionIQDashboard/VirtualOrderConversionCellRenderer';
import VirtualOrderPdfCellRenderer from '../../components/Orders/InvisionIQDashboard/VirtualOrderPdfCellRenderer';
import BetterviewLinkCellRenderer from '../../components/Orders/InvisionIQDashboard/BetterviewLinkCellRenderer';
import { ConfirmationDialog } from '../../components/ConfirmationDialog';
import { Button } from '@material-ui/core';
import QuickVueVirtualToInvisionConversionButton from '../../components/Orders/Buttons/QuickVueVirtualToInvisionConversionButton';
import Loading from '../../components/Loading';
import { OrderDetailBetterViewiFrameTab, } from '../../components/Orders/orderDetailTabs';

// Bringing in app version from Package.json
var { version: appVersion } = require('../../../package.json');

const styles = theme => ({
  main: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  customActionsContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  quickViewButton: {
    marginRight: 15,
  },

  loadingOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(255, 255, 255, 0.6)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
});

const InVisionIQBetterviewPage = withRouter(
  withStyles(styles)(({ classes, match, location, history }) => {
    // #region HOOKS
    //
    // #endregion

    // #region STATE
    const [gridLoading, setGridLoading] = useState(false);
    const [gridApi, setGridApi] = useState(null);
    const [gridData, setGridData] = useState();
    const [selectedQuickView, setSelectedQuickView] = useState(null);
    const [defaultSort, setDefaultSort] = useState(null);

    const [conversionOrders, setConversionOrders] = useState([]);
    const [showConversionDialog, setShowConversionDialog] = useState(false);
    // #endregion

    // #region COMPUTED
    const orderLineId = match?.params?.orderKey;
    // #endregion

    // #region FUNCTIONS
    //
    // #endregion

    // #region EFFECTS

    useEffect(() => {
      // getGridData();
    }, []);
    // #endregion

    return (
      <>
        <div className={classes.main}>
          <OrderDetailBetterViewiFrameTab
            //
            orderLineId={orderLineId}
          />

          <div
            className={classnames('row-center-center', 'bg-white')}
            style={{ padding: 10, fontSize: 12, color: '#aaa' }}
          >
            Client Portal - Version {appVersion}
          </div>
        </div>
      </>
    );
  }),
);

InVisionIQBetterviewPage.propTypes = {};

InVisionIQBetterviewPage.defaultProps = {};

export default InVisionIQBetterviewPage;
